export const SET_TRANSLATION = 'TRANSLATION/SET_TRANSLATION'
export const SET_TRANSLATIONS = 'TRANSLATION/SET_TRANSLATIONS'
export const SET_GROUPS = 'TRANSLATION/SET_GROUPS'
